import React from "react";

import { RegistrationsProvider } from "../context/registrations_context";
import { RegistrationsList } from "../components";
import { useParams } from "react-router-dom";

const AdminRegistrations = () => {
  const { tournamentId } = useParams();

  return (
    <RegistrationsProvider>
      <RegistrationsList tournamentId={tournamentId} />
    </RegistrationsProvider>
  );
};

export default AdminRegistrations;
